<template>
  <div class="container_productfood"  >
    <div class="food_cover" ref="bg_parallax" :style="{backgroundImage:getProductBg()}"></div>
    <b-container v-if="product" fluid style="z-index:2000;position:relative; max-width:1336px;">
      <b-row >
        <b-col class="mt-4" >
          <div @click="back()" style="width:32px;height:32px;border-radius:16px;background-color:#ffffff;">
            <font-awesome-icon style="font-size:24px;margin-top:4px;margin-left:8px;" :style="{color:getCssColor('primary_bt')}" :icon="['fal', 'chevron-left']"/>
          </div>
        </b-col>
      </b-row>
      <b-row class="mt-4 justify-content-center">
        <b-col cols="11" class="product_food_card">
          <span class="name">{{product.name}}</span><br/>
          <span v-if="product.product_views[0].promotional_price" class="price">
            De: R$ <span style="text-decoration:line-through">{{formatPrice(product.product_views[0].price)}}</span> Por: R$ {{formatPrice(product.product_views[0].promotional_price)}}
          </span>
          <span v-else class="price">
            R$ {{formatPrice(product.product_views[0].price)}}
          </span>
        </b-col>
      </b-row>
      <b-row class="mt-4 justify-content-center">
        <b-col cols="10" style="padding:0px;">
          <div class="description_card_food">
            <span style="font-size: 18px;line-height: 20px;color: #525962;">Descrição</span>
            <div style="width:100%; height:2px;border: 1px solid rgba(230, 230, 230, 0.5);margin-top:8px;margin-bottom:8px;" ></div>
            <div v-html="product.description"></div>
          </div>
        </b-col>
      </b-row>
      <template v-if="product.options && product.options.length">
        <template v-for="(option, idxo) in getSortedOptions">

          <b-row class="mt-3" v-if="option.active" v-bind:key="idxo">

            <b-col cols="11" class="mb-3" style="height:44px;background-color:#F4F4F4; border-radius: 0 10px 10px 0;">
              <b-row class="align-items-center">
                <b-col cols="10" class="align-self-center" style="padding-left:40px;line-height:14px;height:44px;">
                  <div class="mt-2">{{option.label}}</div>
                  <!-- 1/1 -->
                  <div v-if="option.min === 1 && option.max === 1" class="product_food_options_size align-self-center" >
                    Selecione 1 opção
                  </div>
                  <!-- > 1 -->
                  <div  v-else-if="option.min > 1" class="product_food_options_size align-self-center">
                    Selecione no mínimo {{option.min}} e no máximo {{option.max}} opções
                  </div>
                  <!-- 0 -->
                  <div  v-else-if="option.min === 0" class="product_food_options_size align-self-center">
                    Selecione até {{option.max}} opções
                  </div>
                </b-col>
                <b-col cols="2" class="text-right">
                  <div v-if="getMinReached(option)"><font-awesome-icon style="font-size:18px;color:#03DE73;margin-top:4px;" :icon="['fas', 'check-circle']"/></div>
                  <div v-else><font-awesome-icon style="font-size:18px;color:#F52D56;margin-top:4px;" :icon="['fas', 'exclamation-circle']"/></div>
                </b-col>
              </b-row>
            </b-col>

            <!-- -->
            <template v-if="option.min === 1 && option.max === 1">
              <b-col cols="11" style="padding-left:40px;background-color:#ffffff;" v-for="(choice, idxc) in option.choices" v-bind:key="idxc">
                <div style="display:inline-flex;margin-top:4px;">
                  <div style="border:1px solid; width:24px;height:24px;border-radius:12px;" :style="{borderColor:getCssColor('primary_bt')}"  @click="selectChoice(option, choice)" :color="getCssColor('primary_bt')">
                    <div v-if="choice.selected_qtd > 0" style="width:12px;height:12px;margin:5px;border-radius:6px" :style="{backgroundColor:getCssColor('primary_bt')}"></div>
                  </div>
                  <div style="margin-left:16px;">{{choice.label}}<span style="font-size:12px;color:#808080;">{{choice.price && choice.price > 0 ? ' + R$' + formatPrice(choice.price) : ''}}</span></div>
                </div>
              </b-col>
            </template>
            <!-- -->
            <template v-else>
              <b-col cols="11" style="padding-left:40px;padding-bottom:8px;background-color:#ffffff;" v-for="(choice, idxc) in option.choices" v-bind:key="idxc">
                <div style="display:inline-flex;margin-top:10px;width:100%;border-bottom:1px solid #EFEDED;padding-bottom:12px;" v-if="choice.active">
                  <div style="width: calc(100% - 70px);">{{choice.label}}<span style="font-size:12px;color:#808080;">{{choice.price && choice.price > 0 ? ' + R$' + formatPrice(choice.price) : ''}}</span></div>
                  <div style="width:80px;height:23px;display:inline-flex;">
                    <div style="width:56px;display:inline-flex;text-align:center;">
                      <font-awesome-icon @click="addRemoveChoice(false, option, choice)" v-show="choice.selected_qtd " style="font-size:22px;" :style="{color:getCssColor('primary_bt')}" :icon="['far', 'minus']"/>
                      <div v-show="choice.selected_qtd" style="width:44px;font-weight:bold;text-align:center;" :style="{color:getCssColor('primary_bt')}">{{choice.selected_qtd}}</div>
                    </div>
                    <div style="width:20px;text-align:right;">
                      <font-awesome-icon @click="addRemoveChoice(true, option, choice)" v-if="!option.maxReached" style="font-size:22px;float:right;" :style="{color:getCssColor('primary_bt')}" :icon="['far', 'plus']"/>
                      <font-awesome-icon v-else style="font-size:22px;float:right;color:#c0c0c0;" :icon="['far', 'plus']"/>
                    </div>
                  </div>
                </div>
              </b-col>
            </template>
            <!-- -->

          </b-row >

        </template>
      </template>

      <b-row class="mt-3">
        <b-col style="padding-left:40px;font-weight:bold;">Comentário Personalizado:</b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="11" style="padding-left:40px;">
          <textarea v-model="productComment" style="border: 1px solid #DCDCDC;border-radius:5px;width:100%" placeholder="Ex: Tirar cebola, maionese à parte, etc.">

          </textarea>
        </b-col>
      </b-row>

      <b-row class="justify-content-center mt-3 pb-4">
        <b-col cols="7" class="text-center">
          <div @click="adicionar()" style="width:100%;height:38px;border:1px solid;border-radius: 5px;display:inline-flex;cursor:pointer;line-height:38px;" :style="{backgroundColor: getCssColor('primary_bt'), borderColor: getCssColor('primary_bt')}">
            <div style="color:#ffffff;text-align:center;width:calc(100% - 75px);font-weight:bold">Adicionar</div>
            <div style="width:75px;height:36px;background-color:#ffffff;border-radius: 5px;font-weight: 500;font-size: 12px;color: #010101;">
              <template v-if="product.product_views[0].promotional_price">
                R$ {{formatPrice(product.product_views[0].promotional_price + getFoodPlus())}}
              </template>
              <template v-else>
                R$ {{formatPrice(product.product_views[0].price + getFoodPlus())}}
              </template>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import cartMixin from '@/mixins/cartMixin'
import navigation from '@/mixins/navigation'
import ProductsConn from '@/connection/productsv2.js'
import formaters from '@/mixins/formaters'
import colors from '@/mixins/colors'
import { EventBus } from '@/behaviours/event-bus'
import _ from 'lodash'

export default {
  data () {
    return {
      product: null,
      productComment: null
    }
  },

  computed: {
    productImageURI () {
      return 'https://cdnimages.opa4.store/productImages'
    },

    getSortedOptions() {
      return _.clone(this.product.options).sort(function(a, b) {
        return a.order - b.order
      })
    }
  },

  mixins: [navigation, colors, formaters, cartMixin],

  async created () {
    // todo on router
    EventBus.$emit('resetScroll')

    console.log('before this', this)

    let p = await ProductsConn.getProductById(this.$route.params.productId)
    if (p) {
      this.product = p
      // register no default selected
      if (this.product.options) {
        this.product.options.forEach((o) => {
          if (o.min === 1 && o.max === 1) {
            this.$data[o.id] = null
          }
          o.maxReached = false
          o.choices.forEach((c) => {
            c.selected_qtd = 0
          })
        })
      }

      console.log(this)

      console.log('mounted food', this)
      EventBus.$emit('resetScroll')
      EventBus.$on('srcollY', (data) => {
        let oldY = data.oldY
        let newY = data.newY
        let topN = Number(this.$refs['bg_parallax'].style.top.replace('px', ''))
        let calc = topN + ((oldY - newY)/2)
        if (newY) {
          this.$refs['bg_parallax'].style.top = calc + 'px'
        } else {
          this.$refs['bg_parallax'].style.top = '0px'
        }
      })


      this.$forceUpdate()
    } else {
      EventBus.$emit('showAlert', 'error', 'Erro ao obter produto')
      this.back()
    }


  },

  destroyed() {
    console.log('destroy food')
    EventBus.$off('srcollY')
    // TESTING IF REAL NEDD TO RESET PRODUCT
    // DELETE THE COMENT BELOW AFTER TEST
    // if (this.product.options) {
    //   this.product.options.forEach((o) => {
    //     delete this.$data[o.id]
    //     o.maxReached = false
    //     o.choices.forEach((c) => {
    //       c.selected_qtd = 0
    //     })
    //   })
    // }
    console.log('if deleted', this)
  },

  methods: {
    async adicionar () {
      if (this.productIsValid()) {
        let productClone = _.clone(this.product)
        await this.addToCart(productClone, productClone.product_views[0].id, this.productComment)
        this.$store.state.searchTerm = ''
        EventBus.$emit('showAlert', 'success', 'Produto adicionado ao carrinho!')
        this.$router.push({path:'/home'})
      } else {
        EventBus.$emit('showAlert', 'warning', 'Uma opção obrigatória não foi selecionada!')
      }
    },

    productIsValid () {
      if (this.product.options) {
        for (let x=0; x<this.product.options.length; x++) {
          let option = this.product.options[x]
          if (option.min > 0) {
            let sumqtd = 0
            for (let y=0; y<option.choices.length; y++){
              let choice = option.choices[y]
              sumqtd = sumqtd + choice.selected_qtd
            }
            if (sumqtd < option.min) {
              return false
            }
          }
        }
      }
      return true
    },

    getProductBg () {
      if (this.product && this.product.photos.length && this.product.photos[0].id) {
        return 'url(' + this.productImageURI + '/' + this.product.photos[0].id + ')'
      } else {
        return 'none'
      }
    },

    getFoodPlus() {
      let price = 0
      if (this.product.options) {
        this.product.options.forEach((o) => {
          o.choices.forEach((c) => {
            if (c.price) {
              price += (c.price * c.selected_qtd)
            }
          })
        })
      }
      return price
    },

    selectChoice (option, choice) {
      option.choices.forEach((c) => {
        this.addRemoveChoice(false, option, c)
      })
      this.addRemoveChoice(true, option, choice)
    },

    addRemoveChoice (add, option, choice) {
      if (add) {
        choice.selected_qtd = choice.selected_qtd + 1
      } else {
        if (choice.selected_qtd > 0) {
          choice.selected_qtd = choice.selected_qtd - 1
        }
      }
      let choiced = option.choices.map( c => c.selected_qtd ).reduce((a, b) => { return a + b })
      if (choiced >= option.max) {
        option.maxReached = true
      } else {
        option.maxReached = false
      }
      this.$forceUpdate()
    },

    getMinReached (option) {
      //radio
      if (option.min === 1 && option.max === 1) {
        if (this[option.id] !== null) {
          return true
        } else {
          return false
        }
      } else if (option.min > 0) {
        let choiced = option.choices.map( c => c.selected_qtd ).reduce((a, b) => { return a + b })
        if (choiced >= option.min) {
          return true
        } else {
          return false
        }
      } else if (option.min === 0 ){
        return true
      }
    }
  }
}
</script>

<style lang="scss">

  .container_productfood{
    min-height:100vh;
    background: linear-gradient(180deg, #FAFAFA 113px, #FEFEFE 113px);
  }

  .food_cover {
    top:0;
    height:149px;
    width: 100vw;
    z-index:1;
    background-size: cover;
    background-position: 0 30%;
    background-repeat: no-repeat;
    position:fixed;
  }

  .product_food_card {
    padding:12px;
    height:69px;
    background: rgba(255,255,255, 0.8);
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.15);
    border-radius: 5px;
    .name {
      font-size: 16px;
      line-height: 20px;
      color: #000000;
    }
    .price {
      font-weight: 500;
      font-size: 18px;
      line-height: 20px;
      color: #525962;
    }
  }

  .description_card_food {
    width:100%;
    min-height:100px;
    background-color:#F7F7F8;
    border-radius:5px;
    padding:8px;
    font-size: 12px;
    line-height: 17px;
    color: #525962;
  }

  .product_food_options_size {
    font-size: 10px;
    line-height: 17px;
    color: #545454;
  }
</style>
